/* global window */
'use strict';

//const ApiActions = require('../../../actions/api');
import Constants from './constants';

import RegisterActions from '../../signup/actions';
import Store from './store';
import ForgotActions from '../../login/actions';
import SignupActions from '../../signup/actions';
import LoginActions from '../../login/actions';


class Actions {

    static forgot(store = Store) {

        store.dispatch({
            type: Constants.FORGOT
        });
    }
    static forgotRecover( data, store = Store ){
        ForgotActions.forgot(data, store);
    }
    static forgotCancel(store = Store) {

        ForgotActions.resetForgot(store);//reset for next use
        store.dispatch({
            type: Constants.FORGOT_CANCEL
        });
    }
    static forgotContinue(store = Store) {

        ForgotActions.resetForgot(store);//reset for next use
        store.dispatch({
            type: Constants.FORGOT_CONTINUE
        });
    }

    static registerSuccess(store = Store){

        store.dispatch({
            type: Constants.REGISTER_SUCCESS
        });
    }

    static registerReset(store = Store){

        SignupActions.registerReset(store);
    }

    static registerUserAutoLogin(data, store = Store, email, password, accountOnly) {

        LoginActions.resetLogin(store);
        RegisterActions.sendRequest(data, store, (err, response) => {
            if ( !err ) {
                Store.dispatch({
                    type: Constants.REGISTER_SUCCESS_AUTO_LOGIN,
                    email,
                    password
                });
            }
        }, accountOnly);
    }

    static registerUser(data, store = Store, accountOnly) {

        LoginActions.resetLogin(store);
        RegisterActions.sendRequest(data, store, (err, response) => {
            if ( !err ) {
                Actions.registerSuccess();
            }
        }, accountOnly);
    }

    static autoLoginClear(store = Store){
        store.dispatch( {
            type: Constants.REGISTER_SUCCESS_AUTO_LOGIN_CLEAR
        });
    }

    static autoLogin(store = Store, cb) {

        const state = store.getState();
        Actions.postSignin({
            username: state.signinOrRegister.auto_login_email,
            password: state.signinOrRegister.auto_login_password,
            stay: true }, store, cb);
    }

    static postSignin( data, store = Store, cb) {

        LoginActions.login(data, store, (err, response) => {

            if (cb){
                cb(err, response);
            }
        });

    }

    static signin(store = Store) {

        store.dispatch( {
            type: Constants.SIGNIN
        });
    }

    static register(store = Store) {

        store.dispatch( {
            type: Constants.REGISTER
        });
    }
}


export default Actions;
